import React, { useEffect, useState } from 'react'

export type DocumentOCRModel = "gemini" | "opus";

const useDocumentOcrModel = () => {
    const [ocrModel, setOcrModel] = useState<DocumentOCRModel>("gemini");

    useEffect(()=>{
        const model = localStorage.getItem("ocrModel") || 'gemini';
        setOcrModel(model as DocumentOCRModel);
    }, [])

    const updateDocumentOcrModel = (model: DocumentOCRModel) =>{
        try {
            localStorage.setItem("ocrModel", model);
            setOcrModel(model)
            return "success"
        } catch (error) {
            return "error"
        }
    }

    return { ocrModel, updateDocumentOcrModel };
}

export default useDocumentOcrModel